import React, { useState } from "react";
import styles from "./VectorControlTabs.module.scss";

const VECTOR_CONTROL_TABS = [
  {
    key: "Kelambu Massal Total",
    label: "Kelambu Massal",
    type: "kelambu",
    fullName: "Kelambu Massal",
  },
  {
    key: "Kelambu Massal Fokus",
    label: "Kelambu Massal Fokus",
    type: "kelambu",
    fullName: "Kelambu Massal Fokus",
  },
  {
    key: "Kelambu PE 1-2-5",
    label: "Kelambu PE 1-2-5",
    type: "kelambu",
    fullName: "Kelambu PE 1-2-5",
  },
  {
    key: "Kelambu KLB/Bencana",
    label: "Kelambu KLB/Bencana",
    type: "kelambu",
    fullName: "Kelambu KLB/Bencana",
  },
  {
    key: "IRS",
    label: "IRS",
    type: "irs",
    fullName: "IRS",
  },
];

const VectorControlTabs = ({
  activeTab = VECTOR_CONTROL_TABS[0].key,
  onTabChange,
  children,
}) => {
  const [currentTab, setCurrentTab] = useState(activeTab);

  const handleTabClick = (tabKey) => {
    setCurrentTab(tabKey);
    if (onTabChange) {
      onTabChange(tabKey);
    }
  };

  const renderTabContent = () => {
    const activeTabData = VECTOR_CONTROL_TABS.find(
      (tab) => tab.key === currentTab
    );

    if (typeof children === "function") {
      return children(activeTabData);
    }

    return children;
  };

  return (
    <div className={styles.vectorControlTabs}>
      <div className={styles.formGroup}>
        <label className={styles.tabLabel}>
          Jenis Pengendalian Vektor <sup className={styles.required}>*</sup>
        </label>

        {/* Custom Styled Tabs Navigation */}
        <div className={styles.navTabs}>
          {VECTOR_CONTROL_TABS.map((tab) => (
            <button
              key={tab.key}
              className={`${styles.navLink} ${
                currentTab === tab.key ? styles.active : ""
              }`}
              type="button"
              onClick={() => handleTabClick(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className={styles.tabContent}>
        <div className={styles.tabPane}>{renderTabContent()}</div>
      </div>
    </div>
  );
};

export { VECTOR_CONTROL_TABS };
export default VectorControlTabs;
